/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".shared-user-info-wrapper[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{min-width:5rem;font-weight:700}.boxForm[_ngcontent-%COMP%]{border:2px solid #eb904b;padding:8px}.link[_ngcontent-%COMP%]{cursor:pointer!important;color:#0056b3!important;text-decoration:none!important}.link[_ngcontent-%COMP%]:active, .link[_ngcontent-%COMP%]:hover{cursor:pointer!important;color:#0056b3!important;text-decoration:underline!important}"];
export { styles as styles };
